import React from "react";

export default function ML_JavaScript() {
  return (
    <div>
      <h1>ML_JavaScript</h1>
      <p>This is the ML_JavaScript component.</p>
    </div>
  );
}
